import {Component, Input, OnInit} from '@angular/core';
import {Project} from '../../models/project';
import {ZoomDialogComponent} from "../../../builder/zoom-dialog/zoom-dialog.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'mbnm-basic-merch',
  templateUrl: './basic-merch.component.html',
  styleUrls: ['./basic-merch.component.scss']
})
export class BasicMerchComponent implements OnInit {

  constructor(public dialog: MatDialog) { }

  @Input()
  project: Project;

  @Input()
  projectPropertyName: string;

  @Input()
  imageUrl: string;

  @Input()
  enlargedImageUrl: string;

  @Input()
  title: string;

  public projectProperty: any;

  ngOnInit() {
    this.projectProperty = this.projectPropertyName ? this.project[this.projectPropertyName] : null;
    this.title = this.projectProperty ? this.projectProperty.description : this.title;
  }

  openZoomDialog() {
    if (this.enlargedImageUrl) {
      const dialogRef = this.dialog.open(ZoomDialogComponent);
      dialogRef.componentInstance.imageUrl = this.enlargedImageUrl;
    }
  }
}
